import { Link, useNavigate } from "react-router-dom"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useEffect, useState } from "react"
import constant from "../../constant"
import services from "../../services"
import Toaster from "../../components/toaster";
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";
import TollNote from "../../components/TollNote";
import MluxDateField from "../../components/MluxDateField";
function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
}
const BookNow = () => {
    const navigate = useNavigate()
    const isMobileView = useIsMobile()
    const [bookingData, setBookingData] = useState()
    const [agreed, setAgreed] = useState(true)
    const [perKmCost, setPerKmCost] = useState()
    const [isAcAvailable, setisAcAvailable] = useState(false)
    const [isCarrierAvailable, setisCarrierAvailable] = useState(false)
    const [userDetails, setUserDetails] = useState()
    const [endDate, setEndDate] = useState()
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [name, setName] = useState()
    const [phoneNumber, setPhoneNumber] = useState()
    const [email, setEmail] = useState()
    const [customerNote, setCustomerNote] = useState()
    const [passengerCount, setPassengerCount] = useState()
    const [minKmPerDay, setMinKmPerDay] = useState(250)
    useEffect(() => {
        services.order.FARE_CONFIG().then((r) => {
            if (r?.data?.minKmPerDay) setMinKmPerDay(Number(r.data.minKmPerDay));
        }).catch(() => {});
    }, [])
    useEffect(() => {
        let data = localStorage.getItem('data');
        if (data) {
            const parsed = JSON.parse(data)
            // Trips are booked by date only (older saves included a time)
            if (parsed?.pickupDate) parsed.pickupDate = String(parsed.pickupDate).slice(0, 10)
            setBookingData(parsed)
            if(JSON.parse(data)?.item.Car){
                setPerKmCost(JSON.parse(data)?.item?.perKmCharge)
            } else {
                setPerKmCost(JSON.parse(data)?.item?.perKmCharge)
            }
            if(JSON.parse(data)?.vacant){
                setPassengerCount(JSON.parse(data)?.vacant)
            }
            let userData = JSON.parse(localStorage.getItem('userDetails'))
            setUserDetails(userData)
            setName(userData.firstName)
            setPhoneNumber(userData.phoneNumber)
            setEmail(userData.email)
        } else {
            navigate('/taxi')
        }

    }, [])
    useEffect(()=>{
        if(bookingData && isAcAvailable){
            if(bookingData?.item.Car){
                setPerKmCost(bookingData?.item?.perKmCharge+1)
            } else {
                setPerKmCost(bookingData?.item?.perKmCharge+1)
            }
        } else if(bookingData) {
            if(bookingData?.item.Car){
                setPerKmCost(bookingData?.item?.perKmCharge)
            } else {
                setPerKmCost(bookingData?.item?.perKmCharge)
            } 
        }
    },[isAcAvailable])
    const showToaster = (type, title, text) => {
        setToaster({ visiblity: "show", type, title, text });
        setTimeout(() => setToaster({ visiblity: "hide" }), 3500);
    };
    // Validate the booking form and surface a clear, specific error to the user.
    const validateBooking = () => {
        const isSharing = bookingData?.tripType === 'sharing';
        const capacity = isSharing
            ? bookingData?.item?.carData?.customerCapacity
            : (bookingData?.item?.Car?.customerCapacity || bookingData?.item?.customerCapacity);
        if (!name || !name.trim()) { showToaster('danger', 'Name required', 'Please enter your name.'); return false; }
        if (!phoneNumber || !/^\d{10}$/.test(String(phoneNumber).trim())) { showToaster('danger', 'Invalid phone number', 'Enter a valid 10-digit mobile number.'); return false; }
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim())) { showToaster('danger', 'Invalid email', 'Enter a valid email address or leave it blank.'); return false; }
        const pc = Number(passengerCount);
        if (!passengerCount || pc < 1) { showToaster('danger', 'Passengers required', 'Enter the number of passengers.'); return false; }
        if (capacity && pc > capacity) { showToaster('danger', 'Too many passengers', `This cab seats up to ${capacity}.`); return false; }
        if (!agreed) { showToaster('danger', 'Please accept the terms', 'Agree to the Terms & Privacy Policy to continue.'); return false; }
        if (!isSharing) {
            if (!endDate) { showToaster('danger', 'Dropping date required', 'Select a dropping date to continue.'); return false; }
            if (bookingData?.pickupDate && new Date(endDate) < new Date(bookingData.pickupDate)) {
                showToaster('danger', 'Check your dates', 'Dropping date must be after the journey date.'); return false;
            }
        }
        return true;
    };
    const requestBookingHandler = async () => {
        if (!validateBooking()) return;
        try {
            let payload = {
                pickupLocation: { lat: bookingData.selectedPickup.geometry.coordinates[1] + '', lng: bookingData.selectedPickup.geometry.coordinates[0] + '', addressLine: bookingData.selectedPickup?.properties?.full_address },
                dropLocation: { lat: bookingData.selectedDrop.geometry.coordinates[1] + '', lng: bookingData.selectedDrop.geometry.coordinates[0] + '', addressLine: bookingData.selectedDrop?.properties?.full_address },
                tripType: bookingData.tripType,
                tripStartDate: bookingData.pickupDate,
                tripEndDate: endDate,
                carId: bookingData.item.id,
                customerNote,
                passengerCount,
                isAcAvailable,
                isCarrierAvailable,
                customerData: {
                    name,
                    email,
                    phoneNumber
                }
            }
            console.log(payload)
            const response = await services.order.REQUEST_BOOKING(payload);
            console.log(response)
            if (response) {
                localStorage.removeItem('data')
                navigate('/mybookings')
            }
        } catch (error) {
            console.log(error)
            showToaster('danger', 'Booking failed', error?.response?.data?.message || 'Could not create the booking. Please try again.')
        }
    }
    const requestVendorBooking = async () => {
        if (!validateBooking()) return;
        try {
            let payload = {
                pickupLocation: { lat: bookingData.selectedPickup.geometry.coordinates[1] + '', lng: bookingData.selectedPickup.geometry.coordinates[0] + '', addressLine: bookingData.selectedPickup?.properties?.full_address },
                dropLocation: { lat: bookingData.selectedDrop.geometry.coordinates[1] + '', lng: bookingData.selectedDrop.geometry.coordinates[0] + '', addressLine: bookingData.selectedDrop?.properties?.full_address },
                tripType: bookingData.tripType,
                tripStartDate: bookingData.pickupDate,
                tripEndDate: endDate,
                vendorCarId: bookingData.item.id,
                customerNote,
                passengerCount,
                isAcAvailable,
                isCarrierAvailable,
                customerData: {
                    name,
                    email,
                    phoneNumber
                }
            }
            console.log(payload)
            const response = await services.order.REQUEST_VENDOR_BOOKING(payload);
            console.log(response)
            if (response) {
                localStorage.removeItem('data')
                navigate('/mybookings')
            }
        } catch (error) {
            console.log(error)
            showToaster('danger', 'Booking failed', error?.response?.data?.message || 'Could not create the booking. Please try again.')
        }
    }
    const requestPaymentHandler = async () => {
        if (!validateBooking()) return;
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );
        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }
        try {
            let total = ((((isAcAvailable ? bookingData.item.carData.perKmCharge+1 : bookingData.item.carData.perKmCharge) * (bookingData.item.distanceBreakdown.distance / 1000)) / ((bookingData.item.carData.customerCapacity - bookingData.item.sharingAvailable) + (+bookingData.vacant))) * bookingData.vacant);
            let commissionp = bookingData.item.vendorData.VendorDetail.sharingCommission;
            let commission = ((total * commissionp) / 100)?.toFixed(0)
            let data = {
                amount: +commission * 100
            }
            let oldBookings = bookingData.item.BookingDetails.map((item) => {
                return {
                    id: item.id,
                    data: {
                        amountBreakdown: {
                            commissionPaid: item.BookingPayment?.BookingPaymentDetails[0].amount / 100,
                            remainingAmount: (total / bookingData.vacant) * item.passengerCount,
                        }
                    }
                }
            })
            console.log(oldBookings)
            const paymentrequest = await services.order.REQUEST_OPEN_PAYMENT(data);
            const options = {
                key: "rzp_live_X9AC4dOucZtKRc",
                currency: "INR",
                amount: +commission * 100,
                order_id: paymentrequest?.data?.response?.id,
                name: "Cars53",
                description: "Thank you for ordering. Please initiate payment!",
                image:
                    "",
                modal: {
                    ondismiss: async () => {
                        // const data = {
                        //     paymentDetailId: paymentrequest.data.bookingPaymentDetail.id,
                        //     paymentStatus: "failure",
                        //     transactionData: {}
                        // };
                        // const response = await services.order.COMPLETE_PAYMENT(data);
                        setToaster({
                            type: "danger",
                            title: "Payment Failed",
                            text: 'Payment Failed',
                            visiblity: "show",
                        });
                        setTimeout(() => {
                            setToaster({
                                type: "danger",
                                title: "Error",
                                text: 'Error',
                                visiblity: "hide",
                            });
                        }, 1500)
                        // getBookingsHandler()
                    },
                },
                handler: function (response) {
                    (async () => {
                        const data = {
                            oldBookings: oldBookings,
                            paymentData: {
                                amountBreakdown: {
                                    commissionPaid: commission,
                                    remainingAmount: total
                                }, transactionData: response, amount: +commission * 100
                            },
                            newBooking: {
                                amountBreakdown: {
                                    commissionPaid: commission,
                                    remainingAmount: total
                                },


                                passengerCount: bookingData.vacant,

                                customerNote: customerNote,
                                customerData: {
                                    name,
                                    email,
                                    phoneNumber
                                },
                                bookingId: bookingData.item.id

                            },
                            bookingData : {
                                sharingAvailable : (bookingData.item.carData.customerCapacity - ((bookingData.item.carData.customerCapacity - bookingData.item.sharingAvailable) + (+bookingData.vacant)))
                            }

                        };
                        const responsesuccess = await services.order.CREATE_SHARING_BOOKING(data);

                        setToaster({
                            type: "success",
                            title: "Payment Done!",
                            text: 'Payment Done successfully!',
                            visiblity: "show",
                        });
                        setTimeout(() => {
                            setToaster({
                                type: "danger",
                                title: "Error",
                                text: 'Error',
                                visiblity: "hide",
                            });
                            if (responsesuccess) {
                                localStorage.removeItem('data')
                                navigate('/mybookings')
                            }
                        }, 1500)
                        // getBookingsHandler()
                    })();
                },
                prefill: {
                    name: name,
                    email: email,
                    phone_number: phoneNumber,
                },
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobileView) {
        if (!bookingData) {
            return (<main className="mlux" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}><div className="mlux-empty"><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading your booking…</h4></div></main>);
        }
        const isSharing = bookingData?.tripType === 'sharing';
        const twoway = bookingData?.tripType === 'twoway';
        const car = isSharing ? bookingData.item.carData : (bookingData.item.Car || bookingData.item);
        const photo = isSharing ? bookingData.item.carData?.photos?.[0] : (bookingData.item.photos ? bookingData.item.photos[0] : bookingData.item.Car?.photos?.[0]);
        // Two-way charges max(minKmPerDay × days, oneWayKm × 2), where days is the
        // inclusive calendar span from journey date to dropping (return) date.
        const calendarDaysInclusive = (s, e) => {
            if (!s || !e) return 1;
            const ms = Date.parse(String(s).slice(0, 10));
            const me = Date.parse(String(e).slice(0, 10));
            if (Number.isNaN(ms) || Number.isNaN(me)) return 1;
            const d = Math.floor((me - ms) / 86400000) + 1;
            return d < 1 ? 1 : d;
        };
        const twowayDays = twoway ? calendarDaysInclusive(bookingData.pickupDate, endDate) : 1;
        const twowayKm = twoway ? Math.max(minKmPerDay * twowayDays, bookingData.totalKm * 2) : 0;
        const km = isSharing ? (bookingData.item.distanceBreakdown.distance / 1000) : (twoway ? twowayKm : bookingData.totalKm);
        const baseFare = isSharing
            ? (((perKmCost * (bookingData.item.distanceBreakdown.distance / 1000)) / ((bookingData.item.carData.customerCapacity - bookingData.item.sharingAvailable) + (+bookingData.vacant))) * bookingData.vacant)
            : (twoway ? perKmCost * twowayKm : perKmCost * bookingData.totalKm);
        const fare = Number(baseFare || 0);
        const confirm = () => { bookingData.item?.vendorId ? requestVendorBooking() : (isSharing ? requestPaymentHandler() : requestBookingHandler()); };
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux">
                    <MobileHeader back="/taxi" />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Almost there</div>
                        <div className="nm" style={{ fontSize: 24 }}>Confirm booking</div>
                    </div>

                    <div className="mlux-card mlux-car" data-rise="1">
                        <div className="ph">
                            <img src={constant.IMAGE_URL + photo} crossOrigin="anonymous" alt={`${car?.brand} ${car?.name}`} />
                        </div>
                        <div className="bd">
                            <div className="nm">{car?.brand} {car?.name}</div>
                            <div className="feats" style={{ marginBottom: 0 }}>
                                <span className="feat"><i className="fas fa-route"></i> {twoway ? 'Two Way' : isSharing ? 'Sharing' : 'One Way'}</span>
                                <span className="feat"><i className="far fa-road"></i> {km?.toFixed(0)} KM</span>
                                {bookingData?.duration && <span className="feat"><i className="far fa-clock"></i> {bookingData.duration}</span>}
                            </div>
                        </div>
                    </div>

                    <div className="mlux-route mlux-card" style={{ padding: '16px 16px 16px 40px', marginTop: 12 }} data-rise="2">
                        <div className="pt from"><small>Pickup</small>{bookingData?.selectedPickup?.properties?.full_address}</div>
                        <div className="pt to"><small>Drop</small>{bookingData?.selectedDrop?.properties?.full_address}</div>
                    </div>

                    <div className="mlux-sec-head"><h3>Ride options</h3></div>
                    <div className="mlux-switch" data-rise="2">
                        <div className="lb"><i className="far fa-snowflake"></i><div>Air Conditioning<small>+ ₹1/km</small></div></div>
                        <button type="button" className={`mlux-sw ${isAcAvailable ? 'on' : ''}`} onClick={() => setisAcAvailable(!isAcAvailable)}></button>
                    </div>
                    <div className="mlux-switch" data-rise="2">
                        <div className="lb"><i className="far fa-suitcase-rolling"></i><div>Luggage Carrier</div></div>
                        <button type="button" className={`mlux-sw ${isCarrierAvailable ? 'on' : ''}`} onClick={() => setisCarrierAvailable(!isCarrierAvailable)}></button>
                    </div>

                    <div className="mlux-sec-head"><h3>Your details</h3></div>
                    <div className="mlux-card" style={{ padding: 16 }} data-rise="3">
                        <label className="mlux-lbl">Name</label>
                        <div className="mlux-field no-icon"><input type="text" value={name || ''} placeholder="Your name" onChange={(e) => setName(e.target.value)} /></div>
                        <label className="mlux-lbl">Phone</label>
                        <div className="mlux-field no-icon"><input type="tel" value={phoneNumber || ''} placeholder="Phone" onChange={(e) => setPhoneNumber(e.target.value)} /></div>
                        <label className="mlux-lbl">Email</label>
                        <div className="mlux-field no-icon"><input type="email" value={email || ''} placeholder="Email" onChange={(e) => setEmail(e.target.value)} /></div>
                        <label className="mlux-lbl">Passengers{car?.customerCapacity ? ` (max ${car.customerCapacity})` : ''}</label>
                        <div className="mlux-field no-icon"><input type="number" min="1" max={car?.customerCapacity} value={passengerCount || ''} placeholder="No. of passengers" onChange={(e) => { (e.target.value === '' || Number(e.target.value) <= (car?.customerCapacity || 99)) && setPassengerCount(e.target.value) }} /></div>
                        <label className="mlux-lbl">Journey date</label>
                        <MluxDateField value={bookingData?.pickupDate} placeholder="Journey date" disabled />
                        {!isSharing && <>
                            <label className="mlux-lbl">Dropping date <span style={{ color: '#ef4444' }}>*</span></label>
                            <MluxDateField value={endDate} min={bookingData?.pickupDate} placeholder="Select dropping date" onChange={setEndDate} />
                        </>}
                        <label className="mlux-lbl">Note for driver (optional)</label>
                        <div className="mlux-field no-icon"><textarea rows="3" value={customerNote || ''} placeholder="Any special request…" onChange={(e) => setCustomerNote(e.target.value)} style={{ width: '100%', borderRadius: 'var(--radius-sm)', border: '1px solid var(--hairline)', background: 'var(--surface-solid)', padding: 12, fontSize: 16, resize: 'vertical' }}></textarea></div>
                    </div>

                    <div className="mlux-card mlux-fare" style={{ marginTop: 16 }} data-rise="3">
                        <div className="r"><span>Distance</span><b>{km?.toFixed(0)} km</b></div>
                        <div className="r"><span>Rate {isAcAvailable ? '(incl. AC)' : ''}</span><b>₹{perKmCost}/km</b></div>
                        <div className="r tot"><span className="lbl">Estimated fare</span><span className="amt">₹{fare.toFixed(0)}</span></div>
                        <TollNote style={{ textAlign: 'right', marginTop: 4 }} />
                    </div>

                    {twoway && (
                        <div className="mlux-note" style={{ marginTop: 14 }}>
                            <i className="far fa-circle-info"></i>
                            <span>Round trips are billed at a minimum of <b>{minKmPerDay} km per day</b>. Driver allowance (batta), toll and state taxes are <b>not included</b> and are payable directly as per actuals.</span>
                        </div>
                    )}

                    <label className="mlux-agree">
                        <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
                        <span>I agree to the <Link to="/terms">Terms &amp; Conditions</Link> and <Link to="/privacy">Privacy Policy</Link>.</span>
                    </label>
                    <button className="mlux-btn" style={{ marginTop: 8 }} disabled={(!isSharing && !endDate) || !agreed} onClick={confirm}>
                        <i className="far fa-circle-check"></i> {bookingData.item?.vendorId ? 'Confirm booking' : isSharing ? 'Pay & book' : 'Book your taxi'}
                    </button>
                    {!isSharing && !endDate && <div style={{ textAlign: 'center', fontSize: 12.5, color: 'var(--muted)', fontWeight: 600, marginTop: 8 }}>Select a dropping date to continue</div>}
                    <Link to="/taxi" className="mlux-btn ghost" style={{ marginTop: 12, textDecoration: 'none' }}><i className="fas fa-arrow-left"></i> Edit details</Link>
                </main>
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />
            <div class="site-breadcrumb" style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}>
                <div class="container">
                    <h2 class="breadcrumb-title">Book A Ride</h2>
                    <ul class="breadcrumb-menu">
                        <li><a href="index.html">Home</a></li>
                        <li class="active">Book A Ride</li>
                    </ul>
                </div>
            </div>


            <div class="book-ride py-5">
                <div class="container">
                    <div class="row">

                        <div class="col-md-10 mx-auto">
                            <div class="booking-form">
                                <div class="book-ride-head">
                                    <h4 class="booking-title">Confirm your booking</h4>
                                    <p>It is a long established fact that a reader will be distracted by the readable
                                        content of a page when looking at its layout. The point of using is that it has
                                        distribution of letters to using content here making it look like readable.</p>
                                </div>
                                {bookingData?.tripType != 'sharing' ?
                                    <div class="col-md-12 col-lg-12 filter-item cat1 cat2">
                                        <div class="row align-items-center ">
                                            <a className="col-md-6 col-12"><div class="taxi-img text-center">
                                                <img src={constant.IMAGE_URL + (bookingData?.item.photos ? bookingData?.item.photos[0] : bookingData?.item.Car.photos[0])} crossorigin="anonymous" style={{height:'350px', width:'100%', objectFit: 'cover'}} />
                                            </div></a>
                                            <div class="taxi-content col-md-6 col-12">
                                                <div class="taxi-head">
                                                    <span> <b>Selected Car</b></span><h4>{bookingData?.item.Car ? bookingData?.item.Car.brand : bookingData?.item.brand} {bookingData?.item.Car ? bookingData?.item.Car.name : bookingData?.item.name}</h4>

                                                </div>
                                                <div class="taxi-feature">
                                                    <ul className="">
                                                        <li> Estimated KM: <span> <b>{bookingData?.tripType == 'twoway' ? (bookingData?.totalKm * 2)?.toFixed(0) : (bookingData?.totalKm)?.toFixed(0)} KM</b></span></li>
                                                        <li> Estimated Time: <span> <b>{bookingData?.duration} <small>(for oneway)</small></b></span></li>
                                                        <li> Estimated Fare: <span> <b>Rs. {bookingData?.tripType == 'twoway' ? ((perKmCost * bookingData?.totalKm) * 2)?.toFixed(0) : (perKmCost * bookingData?.totalKm)?.toFixed(0)}</b></span></li>
                                                        <li> Trip Type: <span> <b>{bookingData?.tripType}</b></span></li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div> :
                                    <div class="col-md-12 col-lg-12 filter-item cat1 cat2">

                                        <div class="row align-items-center ">
                                            <a className="col-md-6 col-12"><div class="taxi-img text-center">
                                                <img src={constant.IMAGE_URL + bookingData?.item.carData.photos[0]} crossorigin="anonymous" width={'350px'} />
                                            </div></a>
                                            <div class="taxi-content col-md-6 col-12">
                                                <div class="taxi-head">
                                                    <span> <b>Selected Car</b></span><h4>{bookingData?.item.carData.brand} {bookingData?.item.carData.name}</h4>

                                                </div>
                                                <div class="taxi-feature">
                                                    <ul className="">
                                                        <li> Estimated KM: <span> <b>{bookingData?.item.distanceBreakdown.distance / 1000} KM</b></span></li>
                                                        
                                                        <li> Estimated Fare: <span> <b>Rs. {(((perKmCost * (bookingData.item.distanceBreakdown.distance / 1000)) / ((bookingData.item.carData.customerCapacity - bookingData.item.sharingAvailable) + (+bookingData.vacant))) * bookingData.vacant)?.toFixed(0)}</b></span></li>
                                                        <li> Trip Type: <span className="text-capitalize"> <b>{bookingData?.tripType}</b></span></li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>}

                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Full Name</label>
                                            <input type="text" class="form-control" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} />
                                            <i class="far fa-user"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Phone Number</label>
                                            <input type="text" class="form-control" placeholder="Your Phone" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                                            <i class="far fa-phone"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input type="text" class="form-control" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                            <i class="far fa-envelope"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Passenger Count</label>
                                            <input type="text" class="form-control" placeholder="Enter total passenger" value={passengerCount} onChange={(e) => { e.target.value <= (bookingData.item.Car ? bookingData.item.Car.customerCapacity : bookingData.item.customerCapacity) && setPassengerCount(e.target.value) }} />
                                            <i class="far fa-envelope"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Pick Up Location</label>
                                            <input type="text" class="form-control" placeholder="Type Location" disabled={true} value={bookingData?.selectedPickup?.properties?.full_address} />
                                            <i class="far fa-location-dot"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Drop Off Location</label>
                                            <input type="text" class="form-control" placeholder="Type Location" disabled={true} value={bookingData?.selectedDrop?.properties?.full_address} />
                                            <i class="far fa-location-dot"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 d-flex gap-3 align-items-center fs-5">
                                        <div class="form-group">
                                            <label for='isAcAvailable'>Ac Required</label>
                                            <input type="checkbox" id="iisAcAvailables" style={{transform: 'scale(1.5)',marginLeft: '10px'}} placeholder="Type Location"  value={isAcAvailable} onChange={(e)=>setisAcAvailable(e.target.checked)} />
                                           
                                        </div>
                                        <div class="form-group">
                                            <label for='isCarrierAvailable'>Carrier Required</label>
                                            <input type="checkbox" id="isCarrierAvailable" placeholder="Type Location" style={{transform: 'scale(1.5)',marginLeft: '10px'}}  value={isCarrierAvailable} onChange={(e)=>setisCarrierAvailable(e.target.checked)} />
                                           
                                        </div>
                                    </div>

                                    {bookingData?.tripType !== 'sharing' && <><div class={`col-lg-6`}>
                                        <div class="form-group">
                                            <label>Pick Up Date</label>
                                            <input type="date" class="form-control" disabled={true} value={bookingData?.pickupDate || ''} />
                                            <i class="far fa-calendar-days"></i>
                                        </div>
                                    </div>
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label>Dropping Date</label>
                                                <input type="date" value={endDate || ''} min={bookingData?.pickupDate} onChange={(e) => setEndDate(e.target.value)} class="form-control" />
                                                <i class="far fa-calendar-days"></i>
                                            </div>
                                        </div></>}


                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <label>Your Message</label>
                                            <textarea class="form-control" rows="5" value={customerNote} onChange={(e) => setCustomerNote(e.target.value)}
                                                placeholder="Write Your Message"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="condition" />
                                            <label class="form-check-label" for="condition">
                                                By using this form you agree to our terms & conditions.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-lg-10 col-12 mx-auto d-lg-flex d-block">
                                        <Link to={'/taxi'} class="theme-btn bg-secondary text-white mx-lg-4 mx-0" ><i
                                            class="fas fa-arrow-left"></i> Edit Details</Link>
                                      {bookingData?.item?.vendorId ?  <button onClick={() => { requestVendorBooking() }} class="theme-btn mx-lg-4 mx-0" >Confirm Booking <i
                                            class="fas fa-arrow-right"></i></button> :  <button onClick={() => { bookingData.tripType == 'sharing' ? requestPaymentHandler() : requestBookingHandler() }} class="theme-btn mx-lg-4 mx-0" >Book Your Taxi<i
                                            class="fas fa-arrow-right"></i></button>}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        {/* <Footer /> */}
    </>
    )
}
export default BookNow